import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { actionChangeAppProps } from "../actions/AppAction";
import { LOGIN } from "../config/RoutesConstants";
import { Card, CardHeader, CardText } from "material-ui/Card";
import {
	BarChart,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	Bar,
	Pie,
	PieChart,
	Cell,
	ComposedChart,
	Line
} from "recharts";

class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false
		};
	}
	componentWillMount() {
		if (!this.props.login) {
			this.props.history.push(LOGIN);
		}
	}
	renderCustomizedLabel = ({
		cx,
		cy,
		midAngle,
		innerRadius,
		outerRadius,
		percent,
		index
	}) => {
		const RADIAN = Math.PI / 180;
		const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);
		return (
			<text
				x={x}
				y={y}
				fill="white"
				textAnchor={x > cx ? "start" : "end"}
				dominantBaseline="central"
			>
				{`${(percent * 100).toFixed(0)}%`}
			</text>
		);
	};
	render() {
		const data = [
			{ name: "Preveer", facturacion: 4060000, pv: 2400, amt: 2400 },
			{ name: "Gueseg", facturacion: 5656647, pv: 4800, amt: 2181 },
			{ name: "Frama", facturacion: 6867776, pv: 1398, amt: 2210 },
			{ name: "Watchman", facturacion: 7787879, pv: 9800, amt: 2290 },
			{ name: "Prosegur", facturacion: 7897765, pv: 3908, amt: 2000 }
		];
		const conLineas = [
			// 	{ name: "Febrero 17", Afiliados: 590, pv: 800, amt: 1400 },
			// 	{ name: "Marzo 17", Afiliados: 868, pv: 967, amt: 1506 },
			// 	{ name: "Abril 17", Afiliados: 1397, pv: 1098, amt: 989 },
			// 	{ name: "Mayo 17", Afiliados: 1480, pv: 1200, amt: 1228 },
			// { name: "Junio", Afiliados: 1520, pv: 1108, amt: 1100 },
			{ name: "Julio", Afiliados: 1400, pv: 680, amt: 1700 },
			{ name: "Agosto", Afiliados: 1430, pv: 680, amt: 1700 },
			{ name: "Septiembre", Afiliados: 1466, pv: 680, amt: 1700 },
			{ name: "Octubre", Afiliados: 1473, pv: 680, amt: 1700 },
			{ name: "Noviembre", Afiliados: 1490, pv: 680, amt: 1700 },
			{ name: "Diciembre", Afiliados: 1500, pv: 680, amt: 1700 },
			{ name: "Enero", Afiliados: 1500, pv: 680, amt: 1700 }
		];
		const conLineas2 = [
			{ name: "Julio", Ganancia: 120000, pv: 680, amt: 1700 },
			{ name: "Agosto", Ganancia: 143000, pv: 680, amt: 1700 },
			{ name: "Septiembre", Ganancia: 136600, pv: 680, amt: 1700 },
			{ name: "Octubre", Ganancia: 147300, pv: 680, amt: 1700 },
			{ name: "Noviembre", Ganancia: 199000, pv: 680, amt: 1700 },
			{ name: "Diciembre", Ganancia: 150000, pv: 680, amt: 1700 },
			{ name: "Enero", Ganancia: 160000, pv: 680, amt: 1700 }
		];
		const torta = [
			{ name: "Recaudado", value: 75 },
			{ name: "Por Recaudar", value: 25 }
		];
		const COLORS = ["#0088FE", "#00C49F"];
		// {this.props.email && typeof this.props.email !== "object" ? (
		// 	this.props.email.includes("admin") ? (
		return (
			<div>
				{false ? (
					<div>
						<div className="columns-row-between">
							<Card>
								<CardHeader title="TOP 5 Empresas por Facturación" />
								<CardText>
									<BarChart
										width={600}
										height={300}
										data={data}
										margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
									>
										<XAxis dataKey="name" />
										<YAxis />
										<CartesianGrid strokeDasharray="3 3" />
										<Tooltip />
										<Legend />
										<Bar dataKey="facturacion" fill="#82ca9d" />
									</BarChart>
								</CardText>
							</Card>
							<Card style={{ marginLeft: 18 }}>
								<CardHeader title="Porcentaje de Recaudación en el Mes" />
								<CardText>
									<PieChart width={600} height={250}>
										<Pie
											data={torta}
											dataKey="value"
											nameKey="name"
											cx="50%"
											cy="50%"
											// innerRadius={60}
											outerRadius={80}
											fill="#82ca9d"
											label
										>
											{torta.map((entry, index) => (
												<Cell
													key={index}
													fill={COLORS[index % COLORS.length]}
												/>
											))}
										</Pie>
										<Tooltip />
										<Legend />
									</PieChart>
								</CardText>
							</Card>
						</div>
						<div className="columns-row-between">
							<Card style={{ marginTop: 15 }}>
								<CardHeader title="Afiliados por Mes" />
								<CardText>
									<ComposedChart
										width={600}
										height={400}
										data={conLineas}
										margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
									>
										<XAxis dataKey="name" />
										<YAxis />
										<Tooltip />
										<Legend />
										<CartesianGrid stroke="#f5f5f5" />
										<Bar dataKey="Afiliados" barSize={20} fill="#413ea0" />
										<Line
											type="monotone"
											dataKey="Afiliados"
											stroke="#ff7300"
										/>
									</ComposedChart>
								</CardText>
							</Card>
							<Card style={{ marginTop: 15, marginLeft: 18 }}>
								<CardHeader title="Ganancia por Mes" />
								<CardText>
									<ComposedChart
										width={600}
										height={400}
										data={conLineas2}
										margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
									>
										<XAxis dataKey="name" />
										<YAxis />
										<Tooltip />
										<Legend />
										<CartesianGrid stroke="#f5f5f5" />
										<Bar dataKey="Ganancia" barSize={20} fill="#413ea0" />
										<Line type="monotone" dataKey="Ganancia" stroke="#ff7300" />
									</ComposedChart>
								</CardText>
							</Card>
						</div>
					</div>
				) : null}
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		login: store.session.authenticated,
		email: store.session.user
	};
}
export default withRouter(
	connect(mapStateToProps, { actionChangeAppProps })(Home)
);



// WEBPACK FOOTER //
// ./src/screens/Home.js